/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import React from 'react';
import { EnterCode } from '../../components/EnterCode/EnterCode';
import { EnterCodeContainer } from '@exo/frontend-features-insurance-polaris-login-logic';
import { TopTitle } from '../../components/TopTitle/TopTitle';
import * as S from './EnterCodePage.styles';
import { Column, Grid, Row } from '@exo/frontend-components-base';
import { useIntl } from '@exo/frontend-common-i18n';
import { useLocation } from 'react-router-dom';
import { Title } from '@exo/frontend-components-insurance';
import { AuthEndpointsConfig } from '../../authConfig';

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const EnterCodePage = ({ authConfig }: Props) => {
  const location = useLocation();
  const path = location.pathname;
  const isVerifying = path.split('/')[2] === 'new-user-verification';
  const intlPrefix = isVerifying ? 'NewUserVerificationPage' : 'EnterCodePage';
  const query = useQuery();
  const intl = useIntl(`features.polaris-login.polaris-login-ui.pages.${intlPrefix}`);
  const authorisationCode = query.get('authorisationCode');
  const endpoints = {
    authCodeDetails: authConfig?.authCodeDetails,
    enterCode: authConfig?.enterCode
  };
  return (
    <S.EnterCodePage>
      <Title title={intl.msg('page.title', 'Administration') as string} hasMarginBottom />
      <S.Container>
        <TopTitle
          title={intl.msg('page.top.title', 'Step 2') as string}
          subtitle={intl.msg('page.top.subtitle', ' ') as string}
        />
        <S.Title>{intl.msg('form.title', 'Request Authorisation Code Confirmation')}</S.Title>
        <Grid isFluid>
          <Row>
            <Column>
              <EnterCodeContainer
                authorisationCode={authorisationCode ?? undefined}
                endpoints={endpoints}
                render={args => (
                  <EnterCode
                    {...args}
                    isVerifying={isVerifying}
                    intlPrefix={`features.polaris-login.polaris-login-ui.pages.${intlPrefix}`}
                    authConfig={authConfig}
                  />
                )}
              />
            </Column>
          </Row>
        </Grid>
      </S.Container>
    </S.EnterCodePage>
  );
};

type Props = {
  authConfig: AuthEndpointsConfig;
};
